export const excludeTempFormValues = (values) => {
  const {
    toCurrentInputValue,
    ccCurrentInputValue,
    bccCurrentInputValue,
    ...rest
  } = values

  return rest
}
